class ProductSalesPerDayRange{
    constructor({baseUnitSales, baseSales, baseProfit, marketUnitSales, marketSales, marketProfit}){
        return;
    }

}

export { ProductSalesPerDayRange };